<script setup>
defineProps({
  title: { type: String, required: true },
  hasError: { type: Boolean, default: false }
})
</script>
<template>
  <span class="dx-tab-text">{{ title }}</span>
  <q-icon
    v-if="hasError"
    name="mdi-alert-circle"
    size="1.2rem"
    class="q-ml-sm"
    style="color: #c10015"
  />
</template>
